module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Mani Autoship pasūtījumi")])], 1)]), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "ui segment",
    class: {
      loading: _vm.storeStatus.loading
    }
  }, [_c('div', {
    staticClass: "ui icon message"
  }, [_c('img', {
    staticClass: "ui image small",
    attrs: {
      "src": require("../assets/autoship_logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                    Vēlies ietaupīt laiku un naudu?\n                ")]), _vm._v(" "), _c('p', [_vm._v("Izveido regulāru AutoShip pasūtījumu un iegūsti atlaidi katram pasūtījumam.")]), _vm._v(" "), _c('button', {
    staticClass: "ui  green button",
    on: {
      "click": _vm.newAutoship
    }
  }, [_c('i', {
    staticClass: "icon plus"
  }), _vm._v("Pievienot AutoShip")])])])]) : _vm._e(), _vm._v(" "), (_vm.list.length > 0) ? _c('div', {
    staticClass: "ui segment",
    class: {
      loading: _vm.storeStatus.loading
    }
  }, [_c('table', {
    staticClass: "ui selectable table orange"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.list), function(item) {
    return _c('tr', {
      class: {
        warning: item.status == 0
      }
    }, [_c('td', [_vm._v(_vm._s(item.autoship_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('td', [_vm._v("Reizi "), (item.frequency > 1) ? _c('span', [_vm._v(_vm._s(item.frequency) + " nedēļās")]) : _c('span', [_vm._v("nedēļā")]), _vm._v(", " + _vm._s(_vm.localDay(item.delivery_day)))]), _vm._v(" "), (item.next_order) ? _c('td', [_vm._v(_vm._s(item.next_order.delivery_date))]) : _c('td', [_vm._v("n/a")]), _vm._v(" "), (item.status == 1) ? _c('td', [_c('i', {
      staticClass: "icon checkmark"
    }), _vm._v(" Aktīvs")]) : _c('td', [_c('i', {
      staticClass: "warning attention icon"
    }), _vm._v(" Neaktīvs")]), _vm._v(" "), _c('td', [(item.lock == 0) ? _c('button', {
      staticClass: "ui  green button",
      on: {
        "click": function($event) {
          return _vm.goToEditPage(item)
        }
      }
    }, [_vm._v("Rediģēt")]) : _vm._e(), _vm._v(" "), (item.lock == 0) ? _c('button', {
      staticClass: "ui grey icon button",
      on: {
        "click": function($event) {
          return _vm.removeItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "right trash icon"
    })]) : _c('button', {
      staticClass: "ui  green button",
      on: {
        "click": function($event) {
          return _vm.goToEditPage(item)
        }
      }
    }, [_vm._v("Apskatīt")])])])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "ui right floated green button",
    on: {
      "click": _vm.newAutoship
    }
  }, [_c('i', {
    staticClass: "icon plus"
  }), _vm._v("Pievienot AutoShip")]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui basic modal",
    attrs: {
      "id": "autoship-delete-dialog"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "ui custom_brown ok inverted button",
    on: {
      "click": _vm.deleteAutoship
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v("\n          Jā\n        ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nosaukums")]), _vm._v(" "), _c('th', [_vm._v("Adrese")]), _vm._v(" "), _c('th', [_vm._v("Regularitāte")]), _vm._v(" "), _c('th', [_vm._v("Nākošais pasūtījums")]), _vm._v(" "), _c('th', [_vm._v("Statuss")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui icon header"
  }, [_c('i', {
    staticClass: "trash icon"
  }), _vm._v("\n        Vai dzēst ierakstu?\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Dzēšot AutoShip ierakstu, visi nākotnes pasūtījumi tiks atcelti izņemot pasūtījumi, kas jau ir nodoti piegādei!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui grey basic cancel inverted button"
  }, [_c('i', {
    staticClass: "remove icon"
  }), _vm._v("\n          Nē\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66d59fe9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutoshipPage.vue
// module id = 353
// module chunks = 1